import { ButtonComponent, ButtonProps } from '@/components/commons'
import { cssClass } from '@/shared/utils'
import { useRequestConnection } from 'containers/profile-network/hooks/useConnectionsActions'
import { ProfileRelationType } from 'containers/profile/types/profile'
import { getProfileLink, validateConnectionType } from 'containers/profile/utilities/profile'
import { useUser } from 'containers/user/hooks/useUser'
import { ModalRequestConnection } from './ModalRequestConnection'
import { useState } from 'react'
import { useRouter } from 'next/router'
import { APP_LINKS, linkWithParams } from 'utilities/links'
import { User } from 'containers/user/types/user'
import { IUser } from '@/interfaces/user'
import { useDismissRecommendation } from 'containers/recommendations/hooks/useRecommendations'
import { maxWidthButton } from 'containers/profile/styles/buttons.css'

interface RequestConnectionButtonProps extends ButtonProps {
  profile: User | IUser // TODO: joxxe remove IUser
  buttonClassName?: string
  onConnect?: () => void
  useDismiss?: boolean
  onDismiss?: (id: string) => void
  onConnectionRequest?: () => void
  containerClassName?: string
  maxWidthClass?: string
  useViewProfile?: boolean
}

export const RequestConnectionButton = ({
  profile,
  buttonClassName,
  onConnect,
  useDismiss,
  onDismiss,
  containerClassName,
  maxWidthClass,
  useViewProfile,
  onConnectionRequest,
  ...rest
}: RequestConnectionButtonProps) => {
  const { user } = useUser()
  const relationType = validateConnectionType({ user, profile })
  const [showConnectionModal, setShowConnectionModal] = useState(false)
  const { mutateAsync, isLoading: isRequesting } = useRequestConnection()
  const { mutateAsync: dismissProfile, isLoading: isDismissing } =
    useDismissRecommendation()
  const router = useRouter()
  const isLoading = isRequesting || isDismissing

  if (
    relationType !== ProfileRelationType.NONE &&
    relationType !== ProfileRelationType.CONNECTION_REQUESTED &&
    relationType !== null
  ) {
    return null
  }

  const wasRequested = relationType === ProfileRelationType.CONNECTION_REQUESTED

  const handleRequestConnection = async (message: string) => {
    await mutateAsync({
      profile,
      message,
    })
    console.log('Show connection modal 1')
    setShowConnectionModal(false)
    onConnect?.()
  }

  const handleRequestConnectionClick = () => {
    if (onConnectionRequest) {
      onConnectionRequest()
      return
    }
    if (relationType === null) {
      router.push(
        linkWithParams(APP_LINKS.LOGIN, {
          urlCallback: router.asPath,
        })
      )
      return
    }
    setShowConnectionModal(true)
  }

  const dismiss = async () => {
    onDismiss && onDismiss(profile.id)
    await dismissProfile(profile.id)
  }

  return (
    <div className={cssClass(['flex gap-12 items-center', containerClassName])}>
      <ModalRequestConnection
        onClose={() => setShowConnectionModal(false)}
        disabled={isLoading}
        isOpen={showConnectionModal}
        onRequestConnection={handleRequestConnection}
        profileId={profile?.id}
      />
      <ButtonComponent
        size="xSmall"
        className={cssClass([
          'uppercase',
          maxWidthClass ? maxWidthClass : maxWidthButton,
          buttonClassName,
        ])}
        label={wasRequested ? 'Requested' : 'Connect'}
        disabled={isLoading || wasRequested}
        loading={isLoading}
        onClick={handleRequestConnectionClick}
        {...rest}
      />
      {useDismiss && (
        <ButtonComponent
          size="xSmall"
          variation="secondary"
          className={cssClass([
            'uppercase',
            maxWidthClass ? maxWidthClass : maxWidthButton,
            buttonClassName,
          ])}
          label="Dismiss"
          disabled={isLoading}
          loading={isLoading}
          onClick={dismiss}
        />
      )}
      {useViewProfile && (
        <ButtonComponent
          size="xSmall"
          variation="secondary"
          className={cssClass([
            'uppercase',
            maxWidthClass ? maxWidthClass : maxWidthButton,
            buttonClassName,
          ])}
          label="View Profile"
          disabled={isLoading}
          loading={isLoading}
          to={getProfileLink(profile)}
        />
      )}
    </div>
  )
}
